import { Grid, styled } from "@mui/material";
import { SelectField } from "src/components/FormikComponents/SelectField";

// Sort items by three available review statuses.
export type ReviewStatus = "notreviewed" | "reviewed" | "valid" | "errors";

export const reviewStatusOptions = [
  { label: "Show Not Reviewed", value: "notreviewed" },
  { label: "Show Reviewed", value: "reviewed" },
  { label: "Show Reviewed - Valid", value: "valid" },
  { label: "Show Reviewed - Errors", value: "errors" },
];

interface IReviewStatusFilterProps {
  value: ReviewStatus;
  onChange: (filterStatus: ReviewStatus) => void;
}

const OCReviewStatusFilter = styled(Grid)(({ theme }) => ({
  width: 263,
  "& .filter_by_review_status_selection": {
    "& .input_control": {
      "& label": { width: "auto" },
    },
  },
}));

export const ReviewStatusFilter = (props: IReviewStatusFilterProps): JSX.Element => {
  const { value, onChange } = props;

  return (
    <OCReviewStatusFilter container alignItems="center">
      <SelectField
        className="formikSField filter_by_review_status_selection"
        name="filterByReviewStatus"
        label="Review Status"
        isMulti={false}
        onChange={(option) => onChange(option?.value)}
        options={reviewStatusOptions}
        value={reviewStatusOptions?.find((option) => option.value === value)}
        isClearable={true}
      />
    </OCReviewStatusFilter>
  );
};
